// On-chain metrics — RE₿EL LLM pipeline translation (Sprint B).
// id keys preserved from ES.

export const METRICAS_ONCHAIN = [
  {
    id: "fear-greed",
    nombre: "Fear & Greed Index",
    dificultad: "basica",
    descripcion: "Der meistgenutzte Index zur Messung der allgemeinen Marktstimmung im Kryptomarkt. Er kombiniert Volatilität, Momentum, Volumen, soziale Netzwerke, Dominanz und Google-Suchanfragen auf einer Skala von 0 (Extreme Angst) bis 100 (Extreme Gier). Warren Buffett: «Sei gierig, wenn andere Angst haben, und ängstlich, wenn andere gierig sind».",
    apiUrl: "https://api.alternative.me/fng/",
    interpretacion: [
      {
        rango: "0-25",
        senal: "Extreme Angst",
        color: "green",
        descripcion: "Markt in Panik. Historisch ein Kaufsignal für langfristige Holder. Institutionelle akkumulieren still und leise."
      },
      {
        rango: "26-45",
        senal: "Angst",
        color: "lime",
        descripcion: "Negative Stimmung. Retail-Investoren steigen aus. Gelegenheit, bullische Setups zu analysieren."
      },
      {
        rango: "46-55",
        senal: "Neutral",
        color: "yellow",
        descripcion: "Markt im Gleichgewicht. Keine klare Tendenz. Auf Richtungsbestätigung warten."
      },
      {
        rango: "56-75",
        senal: "Gier",
        color: "orange",
        descripcion: "Moderate Euphorie. Der Markt steigt, aber mit Vorsicht. Positionsgrößen reduzieren oder beginnen, Teilgewinne mitzunehmen."
      },
      {
        rango: "76-100",
        senal: "Extreme Gier",
        color: "red",
        descripcion: "Maximale Euphorie. Historisch ein Signal für Marktspitzen. Institutionelle verteilen. Höchste Vorsicht geboten."
      }
    ]
  },
  {
    id: "nupl",
    nombre: "NUPL — Net Unrealized Profit/Loss",
    dificultad: "intermedia",
    descripcion: "Misst, ob Bitcoin-Holder insgesamt unrealisierte Gewinne oder Verluste haben. Berechnet als (Market Cap − Realized Cap) / Market Cap. Einer der zuverlässigsten Indikatoren zur Identifizierung von Zyklushochs und -tiefs.",
    interpretacion: [
      {
        rango: "> 0.75",
        senal: "Euphorie",
        color: "red",
        descripcion: "Die große Mehrheit hat große unrealisierte Gewinne. Zone institutioneller Verteilung. Historisch gehen dem Korrekturen von 50-80% voraus."
      },
      {
        rango: "0.5-0.75",
        senal: "Überzeugung",
        color: "orange",
        descripcion: "Markt reift im Aufwärtszyklus. Noch Spielraum, aber mit höherem Risiko."
      },
      {
        rango: "0.25-0.5",
        senal: "Optimismus",
        color: "lime",
        descripcion: "Gesunde bullische Phase. Guter Einstiegspunkt bei Rücksetzern."
      },
      {
        rango: "0-0.25",
        senal: "Hoffnung",
        color: "green",
        descripcion: "Übergangsphase. Der Markt erholt sich von einem Tief. Akkumulationsgelegenheit."
      },
      {
        rango: "< 0",
        senal: "Kapitulation",
        color: "green",
        descripcion: "Die Mehrheit ist im Verlust. Maximale Panik. Historisch Zone des Zyklustiefs. Beste langfristige Kaufgelegenheit."
      }
    ]
  },
  {
    id: "exchange-flow",
    nombre: "Exchange Inflow / Outflow",
    dificultad: "basica",
    descripcion: "Verfolgt die Bewegung von Bitcoin zu und von zentralisierten Börsen. Wenn Holder BTC an Börsen senden, deutet dies auf Verkaufsabsicht hin (bearish). Wenn sie BTC von Börsen in private Wallets abheben, deutet dies auf Halteabsicht hin (bullish). Nettozuflüsse zu Börsen gehen oft Kursrückgängen voraus.",
    interpretacion: [
      {
        rango: "Inflow alto",
        senal: "Bärisch",
        color: "red",
        descripcion: "Viel BTC fließt zu Börsen. Vorbereitung zum Verkauf. Erhöht kurzfristigen Verkaufsdruck."
      },
      {
        rango: "Outflow alto",
        senal: "Bullisch",
        color: "green",
        descripcion: "Viel BTC verlässt Börsen. Holder verwahren in eigenen Wallets. Reduziert verfügbares Angebot zum Verkauf."
      },
      {
        rango: "Flujo neutro",
        senal: "Kein Signal",
        color: "yellow",
        descripcion: "Auf Preisbestätigung warten. Allein kein Auslöser."
      }
    ]
  },
  {
    id: "mvrv",
    nombre: "MVRV Ratio",
    dificultad: "intermedia",
    descripcion: "Market Value to Realized Value. Vergleicht den aktuellen Marktpreis mit dem durchschnittlichen Preis, zu dem Holder ihr BTC gekauft haben (realisierter Preis). Ein hohes MVRV bedeutet, dass Holder große unrealisierte Gewinne haben und verkaufen könnten. Ein niedriges MVRV (nahe 1) markiert historisch Zyklustiefs.",
    interpretacion: [
      {
        rango: "MVRV > 3.5",
        senal: "Extreme Überbewertung",
        color: "red",
        descripcion: "Holder haben im Durchschnitt das 3,5-fache ihrer Investition als Gewinn. Historisch Zone der Spitze. Nur 3 Mal in der Geschichte von BTC."
      },
      {
        rango: "MVRV 2-3.5",
        senal: "Warnung",
        color: "orange",
        descripcion: "Markt teuer, kann aber weiterlaufen. Exposition schrittweise reduzieren."
      },
      {
        rango: "MVRV 1-2",
        senal: "Gesund",
        color: "lime",
        descripcion: "Markt angemessen bewertet."
      },
      {
        rango: "MVRV < 1",
        senal: "Kapitulation",
        color: "green",
        descripcion: "BTC notiert unter dem durchschnittlichen Kaufpreis aller Holder. Historisch beste langfristige Kaufgelegenheit."
      }
    ]
  },
  {
    id: "dominancia-btc",
    nombre: "Bitcoin-Dominanz (BTC.D)",
    dificultad: "basica",
    descripcion: "Prozentsatz der gesamten Krypto-Marktkapitalisierung, den Bitcoin repräsentiert. Schlüsselindikator, um zu wissen, wann zwischen BTC und Altcoins rotiert werden sollte. Typischer Zyklus: BTC steigt zuerst (D steigt) → ETH und Large Caps folgen → kleine Altcoins explodieren (D fällt) → alles kollabiert → BTC führt wieder.",
    apiUrl: "https://api.coingecko.com/api/v3/global",
    interpretacion: [
      {
        rango: "D > 60% steigend",
        senal: "BTC season",
        color: "orange",
        descripcion: "Kapital fließt in BTC. Konservativer Markt. Zeit, mehr BTC als Altcoins zu halten."
      },
      {
        rango: "D 50-60%",
        senal: "Übergang",
        color: "yellow",
        descripcion: "BTC konsolidiert Führung. Beginnen Sie, ETH und Large Caps zu beobachten."
      },
      {
        rango: "D 40-50% fallend",
        senal: "Altcoin season",
        color: "lime",
        descripcion: "Rotation in qualitativ hochwertige Altcoins. ETH, SOL, BNB führen."
      },
      {
        rango: "D < 40%",
        senal: "Altcoin-Euphorie",
        color: "green",
        descripcion: "Volle Altcoin season. Small Caps vervielfachen sich. Maximales Risiko — die nächste Bewegung ist normalerweise ein Altcoin-Crash."
      }
    ]
  },
  {
    id: "puell-multiple",
    nombre: "Puell Multiple",
    dificultad: "avanzada",
    descripcion: "Misst die Rentabilität der Bitcoin-Miner, indem der tägliche Wert der geschürften BTC mit dem Jahresdurchschnitt verglichen wird. Miner sind strukturelle Verkäufer von BTC, um Betriebskosten zu decken. Ein hoher Puell bedeutet, dass Miner sehr profitabel sind und mehr verkaufen können. Ein sehr niedriger Puell markiert historisch Böden.",
    interpretacion: [
      {
        rango: "Puell > 4",
        senal: "Zyklus-Top",
        color: "red",
        descripcion: "Miner sehr profitabel. Hoher Verkaufsdruck von Minern. Historisch Top-Zone (nur in extremen Bull Markets)."
      },
      {
        rango: "Puell 1-4",
        senal: "Aktiver Markt",
        color: "orange",
        descripcion: "Produktion und Nachfrage im Gleichgewicht."
      },
      {
        rango: "Puell 0.3-0.5",
        senal: "Miner-Kapitulation",
        color: "green",
        descripcion: "Miner in Schwierigkeiten. Die Schwächsten geben auf und der Preis markiert normalerweise einen Boden. Historisch Kaufgelegenheit im Zyklus."
      }
    ]
  }
];

export const RECURSOS_EXTERNOS = [
  {
    nombre: "Glassnode",
    url: "https://glassnode.com",
    desc: "Der professionelle Standard für On-Chain-Metriken. Eingeschränkter kostenloser Plan, Premium für institutionelle Anleger."
  },
  {
    nombre: "CryptoQuant",
    url: "https://cryptoquant.com",
    desc: "Fokus auf Exchange-Flüsse und Miner-Indikatoren. Guter kostenloser Plan."
  },
  {
    nombre: "LookIntoBitcoin",
    url: "https://www.lookintobitcoin.com",
    desc: "Historische BTC-Zyklus-Indikatoren. 100% kostenlos und sehr didaktisch."
  }
];
